export function UpdatesSection() {
  const updates = [
    {
      time: '2024-07-29 14:30',
      title: '某顶流男星机场被拍，身边神秘女子身份曝光',
      tag: '最新',
      tagColor: 'bg-primary-500',
    },
    {
      time: '2024-07-29 11:15',
      title: '知名导演回应选角争议：一切按规矩办事',
      tag: '跟进',
      tagColor: 'bg-accent-500',
    },
    {
      time: '2024-07-29 09:42',
      title: '网红直播翻车事件最新进展：品牌方宣布解约',
      tag: '更新',
      tagColor: 'bg-secondary-500',
    },
    {
      time: '2024-07-28 22:08',
      title: '某女团成员深夜发文疑似回应恋情传闻',
      tag: '',
      tagColor: '',
    },
    {
      time: '2024-07-28 18:55',
      title: '综艺节目组发布声明：不存在剧本操作',
      tag: '',
      tagColor: '',
    },
    {
      time: '2024-07-28 15:20',
      title: '娱乐圈税务稽查范围扩大，新增多名艺人名单',
      tag: '',
      tagColor: '',
    },
    {
      time: '2024-07-28 10:33',
      title: '某演员工作室发律师函：将追究造谣者法律责任',
      tag: '',
      tagColor: '',
    },
    {
      time: '2024-07-27 21:16',
      title: '热门网剧剧组内部矛盾曝光，导演与编剧分歧严重',
      tag: '',
      tagColor: '',
    },
  ];

  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[960px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
            实时快讯
          </h2>
          <p className="text-sm text-foreground-500">分秒必争，不错过任何一条</p>
        </div>

        <div className="relative">
          <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-200"></div>

          <div className="space-y-5 md:space-y-6">
            {updates.map((u, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-5 pl-10 md:pl-12">
                <div className="absolute left-0 top-1 w-[7px] h-[7px] md:w-[9px] md:h-[9px] rounded-full bg-primary-500 ring-4 ring-background-100/70"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400">{u.time}</span>
                    {u.tag && (
                      <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold text-background-50 ${u.tagColor}`}>
                        {u.tag}
                      </span>
                    )}
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 font-medium leading-snug">
                    {u.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <div className="bg-background-100/70 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col md:flex-row items-start gap-6 md:gap-10">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl bg-primary-500">
                <i className="ri-fire-line text-background-50 text-3xl md:text-4xl"></i>
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
                关于黑料吃瓜网
              </h2>
              <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-3">
                <p>
                  黑料吃瓜网是国内领先的娱乐八卦资讯聚合平台，致力于为吃瓜群众提供最新、最全、最真实的
                  娱乐圈、网红圈热点资讯。我们拥有一支专业的采编团队，7×24小时追踪全网动态，
                  确保您能在第一时间获取<strong>黑料吃瓜网站</strong>上的所有精彩内容。
                </p>
                <p>
                  作为行业标杆，黑料吃瓜网始终坚持真实客观的报道原则，所有爆料均经过多方核实。
                  我们提供便捷的<strong>黑料吃瓜网入口</strong>，支持PC和手机版免费观看，
                  并持续更新<strong>最新地址网址入口</strong>，确保用户不受任何访问限制。
                </p>
                <p>
                  无论您是通过搜索<strong>黑料吃瓜网址</strong>找到我们，还是收藏了
                  <strong>黑料吃瓜网入口免费观看</strong>的链接，这里都是您最值得信赖的吃瓜聚集地。
                  每日千万用户的选择，见证了我们的品质与口碑。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FaqSection() {
  const faqs = [
    {
      q: '黑料吃瓜网是什么类型的网站？',
      a: '黑料吃瓜网是一个专注于娱乐圈、网红圈、明星八卦与热点事件追踪的资讯聚合平台，提供最新最全的娱乐爆料和深度分析内容，是国内最受欢迎的吃瓜社区之一。',
    },
    {
      q: '如何找到黑料吃瓜网的最新地址？',
      a: '黑料吃瓜网最新地址持续更新于此页面，建议您收藏本页作为黑料吃瓜网入口。我们会在地址变更时第一时间更新，确保您随时可以通过官网直达访问。',
    },
    {
      q: '黑料吃瓜网入口免费观看需要注册吗？',
      a: '不需要。黑料吃瓜网所有内容完全免费，无需注册即可浏览。您可以直接通过黑料吃瓜网入口免费观看全部资讯，手机版和PC端体验一致流畅。',
    },
    {
      q: '黑料吃瓜网站的内容可信度如何？',
      a: '我们拥有专业的采编团队，所有爆料内容均经过多方核实和交叉验证。虽然我们追求速度，但绝不会以牺牲真实性为代价。每条资讯都会标注信息来源和核实状态。',
    },
    {
      q: '手机版如何使用黑料吃瓜网？',
      a: '直接用手机浏览器打开黑料吃瓜网址即可，页面会自动适配手机屏幕。无需下载APP，支持iOS和Android全平台访问，随时随地畅享吃瓜乐趣。',
    },
    {
      q: '如何向黑料吃瓜网投稿爆料？',
      a: '您可以通过邮件（tips@heiliao.com）或微信（heiliao_chigua）向我们投稿。我们采用加密通道保护爆料人隐私，并严格保密所有投稿人信息，确保您的身份安全。',
    },
  ];

  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[960px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500">关于黑料吃瓜网，你想知道的都在这里</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70"
            >
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2 flex items-start gap-2">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-8">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}